<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <rect width="8" height="3" x="4.5" y=".5" :stroke="color" rx="1" />
      <rect width="12" height="14" x="2.5" y="3.5" :stroke="color" rx="1" />
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M16.611 3c.215 0 .389.224.389.5 0 .245-.138.45-.319.492l-.07.008H.39C.174 4 0 3.776 0 3.5c0-.245.138-.45.319-.492L.389 3H16.61z"
      />
      <rect width="1" height="7" x="5" y="7" :fill="color" rx=".5" />
      <rect width="1" height="7" x="8" y="7" :fill="color" rx=".5" />
      <rect width="1" height="7" x="11" y="7" :fill="color" rx=".5" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
